<template>
  <div class="school-home-page">
    <div class="frame">
      <div class="menu">
        <el-menu :default-active="activeMenu" class="el-menu-demo" background-color="#ffffff" text-color="#383838" active-text-color="#383838" :collapse-transition="false">
          <!--
            <el-submenu  index="1">
              <template slot="title">
                <i style="margin-left: 10px" class="el-icon-data-analysis"></i>
                <span>使用指南</span>
              </template>
              <el-menu-item
                index="school-index"
                @click="$router.push({ name: 'school-index' })"
                ><span style="margin-left: 10px">快捷入口</span></el-menu-item
              >
            </el-submenu>

            <el-submenu index="9">
              <template slot="title">
                <i style="margin-left: 10px" class="el-icon-s-custom"></i>
                <span>招生管理</span>
              </template>
              <el-menu-item
                index="input-student-management"
                @click="$router.push({ name: 'input-student-management' })"
                ><span style="margin-left: 10px">意向客户</span></el-menu-item
              >
              <el-menu-item
        
                index="auditionstudent"
                @click="$router.push({ name: 'auditionstudent' })"
                ><span style="margin-left: 10px">试听管理</span></el-menu-item
              >
            </el-submenu>

            <el-submenu  index="2">
              <template slot="title">
                <i style="margin-left: 10px" class="el-icon-reading"></i>
                <span>前台业务</span>
              </template>

              <el-menu-item
                index="studentmanagement"
                @click="$router.push({ name: 'studentmanagement' })"
                ><span style="margin-left: 10px">学员管理</span></el-menu-item
              >

              <el-menu-item
        
                index="orderpay"
                @click="$router.push({ name: 'orderpay' })"
                ><span style="margin-left: 10px">报名交费</span></el-menu-item
              >

              <el-menu-item
                index="ordercarry"
                @click="$router.push({ name: 'ordercarry' })"
                ><span style="margin-left: 10px">费用结转</span></el-menu-item
              >

              <el-menu-item
                index="refund"
                @click="$router.push({ name: 'refund' })"
                ><span style="margin-left: 10px">学员退费</span></el-menu-item
              >
            </el-submenu>

            <el-submenu index="3">
              <template slot="title">
                <i style="margin-left: 10px" class="el-icon-school"></i>
                <span>教务中心</span>
              </template>
              <el-menu-item
                index="class-management"
                @click="$router.push({ name: 'class-management' })"
                ><span style="margin-left: 10px">班级管理</span></el-menu-item
              >

              <el-menu-item
                index="teachplan"
                @click="$router.push({ name: 'teachplan' })"
                ><span style="margin-left: 10px">排课管理</span></el-menu-item
              >
            </el-submenu>

            <el-menu-item
              index="course-list"
              @click="$router.push({ name: 'course-list' })"
            >
              <i style="margin-left: 10px" class="el-icon-document"></i>
              <span slot="title">课程管理</span>
            </el-menu-item>

            <el-submenu  index="7">
              <template slot="title">
                <i style="margin-left: 10px" class="el-icon-guide"></i>
                <span>营销物料</span>
              </template>
              <el-menu-item index="workFlowEngineList12"
                ><span style="margin-left: 10px">招生资料</span></el-menu-item
              >
            </el-submenu>

            <el-submenu index="6">
              <template slot="title">
                <i style="margin-left: 10px" class="el-icon-s-finance"></i>
                <span>报表分析</span>
              </template>
              <el-menu-item
                index="order-report"
                @click="$router.push({ name: 'order-report' })"
                ><span style="margin-left: 10px">收费报表</span></el-menu-item
              >
              <el-menu-item
                disabled
                index="refund-list"
                @click="$router.push({ name: 'refund-list' })"
                ><span style="margin-left: 10px">课消报表</span></el-menu-item
              >

              <el-menu-item
                disabled
                index="refund-list"
                @click="$router.push({ name: 'refund-list' })"
                ><span style="margin-left: 10px">业绩报表</span></el-menu-item
              >

              <el-menu-item
                disabled
                index="refund-list"
                @click="$router.push({ name: 'refund-list' })"
                ><span style="margin-left: 10px">班级报表</span></el-menu-item
              >
            </el-submenu>

            <el-submenu  index="0">
              <template slot="title">
                <i style="margin-left: 10px" class="el-icon-s-tools"></i>
                <span>系统设置</span>
              </template>

              <el-menu-item
                index="admin-basic-settings"
                @click="$router.push({ name: 'admin-basic-settings' })"
                ><span style="margin-left: 10px">基础设置</span></el-menu-item
              >

              <el-menu-item
                index="school-user-list"
                @click="$router.push({ name: 'school-user-list' })"
                ><span style="margin-left: 10px">员工设置</span></el-menu-item
              >

              <el-menu-item
                index="home-carousel"
                @click="$router.push({ name: 'home-carousel' })"
                ><span style="margin-left: 10px">主页设置</span></el-menu-item
              >

              <el-menu-item
                disabled
                index="owncourse-list"
                @click="$router.push({ name: 'owncourse-list' })"
                ><span style="margin-left: 10px">课程设置</span></el-menu-item
              >

              <el-menu-item
                index="roleauth"
                @click="$router.push({ name: 'roleauth' })"
                ><span style="margin-left: 10px">权限设置</span></el-menu-item
              >
            </el-submenu>
  -->

          <el-submenu v-for="(item, index) of $store.getters.permisionList" :key="index" :index="index.toString()">
            <template slot="title">
              <i style="margin-left: 10px; font-size: 20px" :class="item.iconUrl"></i>
              <span style="font-size: 16px;margin-left:10px;">{{
                item.name
              }}</span>
            </template>
            <template v-for="(item2, childIndex) of item.children">
              <el-menu-item v-if="item2" :key="childIndex" :index="item2.alias.split(',')[0].toString()" @click="onChangeMenu(item2)" :disabled="item2.alias == '/'">
                <span style="margin-left: 30px">
                  {{ item2.name }}
                </span>
              </el-menu-item>
            </template>
          </el-submenu>
        </el-menu>
      </div>
      <section>
        <container :routerKey="routerKey"></container>
      </section>
    </div>
  </div>
</template>

<script>
import container from './container'
//import schoolCommonImage from "@/components/schoolCommonImage";

export default {
  name: 'frame',
  components: {
    container,
    //schoolCommonImage,
  },

  data() {
    return {
      //角色权限控制
      is_principal: false, //超级管理员
      routerKey: '',
    }
  },

  mounted() {
    this.is_principal = this.$store.getters.is_principal
    //const roleList = this.$store.getters.roleList;
    console.log('全局权限表')
    console.log(this.$store.getters.permisionList)
    document.getElementById('home_top').style.display = 'block'
    document.getElementById('home_bottom').style.display = 'none'
  },

  computed: {
    activeMenu() {
      const route = this.$route
      const { meta, name } = route
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return name
    },
  },
  methods: {
    onChangeMenu(item2) {
      console.log(item2)
      const targetRouteName = item2.alias.split(',')[0];
      // const routes = this.$router.options.routes;
      // const indexRoutes = routes.find(item => item.name === 'index').children;
      // const schoolRoutes = indexRoutes.find(item => item.name === 'school-home-page').children;
      // schoolRoutes.forEach(item => {
      //   if (item.name === targetRouteName) {
      //     // item.meta.routeKey = Date.now()
      //     // this.$router.push({ name: targetRouteName })
      //   }
      // })
      // this.routerKey = Date.now()
      // this.$nextTick(() => {
      //   this.routerKey = ''
      // })
      window.sessionStorage.removeItem('stuManagementCacheData')
      window.sessionStorage.removeItem('classManagementCacheData')
      this.$router.push({ name: targetRouteName })
    }
  },
}
</script>

<style scoped lang="scss">
.school-home-page {
  height: calc(100% - 60px);

  .frame {
    display: flex;
    width: 100%;
    height: 100%;

    background: #f1f7fe;

    .menu {
      overflow-y: scroll;
      overflow-x: hidden;
      width: 220px;
      box-shadow: 0 -8px 10px 2px #f6f7fd;
      background-color: white;

      header {
        height: 30px;
      }

      .header-title {
        padding: 5px 0;
        background: #4084ff;
        color: #ffffff;
        font-size: 20px;
        text-align: center;
      }

      .el-menu-demo:not(.el-menu--collapse) {
        width: 220px;
      }

      .el-menu-demo {
        min-height: 100%;
        border: 0px !important;
        border-radius: 10px !important;
      }

      .el-menu-item.is-active {
        background-color: #f6f7fd !important;
      }

      /deep/.el-menu-demo .el-submenu {
        margin-left: 10px !important;
        margin-right: 10px !important;
        margin-top: 5px !important;
        margin-bottom: 5px !important;
        border-radius: 10px !important;
        min-width: auto;
        line-height: 50px !important;
      }

      /deep/.el-menu-demo .el-menu-item {
        margin-top: 5px !important;
        margin-bottom: 5px !important;
        border-radius: 10px !important;
      }

      /deep/.el-menu .el-menu-item:hover {
        outline: 0 !important;
        color: #2e95fb !important;
        background: linear-gradient(
          270deg,
          #f2f7fc 100%,
          #fefefe 0%
        ) !important;
        border-radius: 10px !important;
      }

      /deep/.el-menu .el-menu-item.is-active {
        color: #2e95fb !important;
        background: linear-gradient(
          270deg,
          #f2f7fc 100%,
          #fefefe 0%
        ) !important;
        border-radius: 10px !important;
      }

      .el-submenu /deep/.el-submenu__title:hover {
        color: #2e95fb !important;
        background: linear-gradient(
          270deg,
          #f2f7fc 100%,
          #fefefe 0%
        ) !important;
        border-radius: 10px !important;
      }
    }

    .menu::-webkit-scrollbar {
      display: none;
    }

    section {
      flex: 1;
      overflow-y: scroll;
    }
  }
}
</style>
